import {
  Exercise,
  Lecture,
  NoTimeExercise,
  Section,
  StaffExercise,
  Tutorial,
} from 'Utils/TutorialConfigHelper';
import { AddEventsAndMergeTimestamps, Timestamps } from 'Utils/ChaptersToTimestamps';
import timestamps from './level17.json';

const Level17 = Tutorial(17, '3:35', [
  Section([
    Lecture('Six Notes in the Right Hand', '0:0'),
    Exercise(
      'Playing C to A',
      '0:12',
      NoTimeExercise({
        centre_align_horizontal: true,
        objectives: [{}, {}],
      }),
      [],
    ),
  ]),
  Section([
    Lecture('Finger Numbers', '0:26'),
    Lecture('Right Hand Stretch', '0:54'),
    Exercise(
      'Right Hand Stretch',
      '1:29',
      NoTimeExercise({
        centre_align_horizontal: true,
        objectives: [{}, {}],
      }),
      [],
    ),
    Lecture('Right Hand Squeeze', '1:46'),
    Exercise(
      'Right Hand Squeeze',
      '2:18',
      NoTimeExercise({
        centre_align_horizontal: true,
        objectives: [{}, {}],
      }),
      [],
    ),
    Lecture('Right Hand Hop', '2:27'),
    Exercise(
      'Right Hand Hop',
      '2:50',
      NoTimeExercise({
        centre_align_horizontal: true,
        objectives: [{}, {}],
      }),
      [],
    ),
    Exercise(
      'Playing in Time',
      '3:01',
      StaffExercise({
        objectives: [
          {
            tempo: 72,
          },
        ],
      }),
      [],
    ),
  ]),
  Section([
    Lecture('Using Both Hands', '3:07'),
    Exercise(
      'Alternating Hands',
      '3:14',
      StaffExercise({
        objectives: [{ tempo: 72 }],
      }),
      [],
    ),
    Exercise(
      'Hands Together',
      '3:21',
      StaffExercise({
        objectives: [{ tempo: 72 }, { tempo: 72 }],
      }),
      [],
    ),
  ]),
]);

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level17);
